/** The shop's licensed devices. */
const devices = {
  en: {
    title: "Devices",
    subtitle: "The phones, tablets and computers signed in to this shop.",
    loadFailed: "Could not load this shop's devices.",
    releaseFailed: "Could not release that device.",
    inUse: "{used} of {limit} devices in use",
    allTaken:
      "All slots are taken — release one below to set up another device.",
    available: { one: "{count} still available", other: "{count} still available" },
    thisDevice: "this device",
    unused: "unused",
    lastUsed: "Last used {when}",
    never: "never",
    daysAgo: { one: "{count} day ago", other: "{count} days ago" },
    signsOut: "This will sign this device out.",
    releaseIt: "Release it?",
    release: "Release",
    releasing: "Releasing…",
    moreDevices:
      "Need more than {limit} devices? That is a change to your subscription — get in touch and we will raise the limit.",
  },

  fr: {
    title: "Appareils",
    subtitle: "Les téléphones, tablettes et ordinateurs connectés à cette boutique.",
    loadFailed: "Impossible de charger les appareils de la boutique.",
    releaseFailed: "Impossible de libérer cet appareil.",
    inUse: "{used} appareils utilisés sur {limit}",
    allTaken:
      "Tous les emplacements sont pris — libérez-en un ci-dessous pour configurer un autre appareil.",
    available: { one: "encore {count} disponible", other: "encore {count} disponibles" },
    thisDevice: "cet appareil",
    unused: "inutilisé",
    lastUsed: "Dernière utilisation : {when}",
    never: "jamais",
    daysAgo: { one: "il y a {count} jour", other: "il y a {count} jours" },
    signsOut: "Cela déconnectera cet appareil.",
    releaseIt: "Le libérer ?",
    release: "Libérer",
    releasing: "Libération…",
    moreDevices:
      "Besoin de plus de {limit} appareils ? Cela dépend de votre abonnement — contactez-nous et nous augmenterons la limite.",
  },

  ar: {
    title: "الأجهزة",
    subtitle: "الهواتف والأجهزة اللوحية والحواسيب المسجّلة في هذا المتجر.",
    loadFailed: "تعذّر تحميل أجهزة المتجر.",
    releaseFailed: "تعذّر تحرير هذا الجهاز.",
    inUse: "{used} من أصل {limit} أجهزة مستخدمة",
    allTaken: "جميع الأماكن مشغولة — حرّر أحدها أدناه لإعداد جهاز آخر.",
    available: {
      one: "لا يزال مكان واحد متاحاً",
      two: "لا يزال مكانان متاحين",
      few: "لا تزال {count} أماكن متاحة",
      other: "لا يزال {count} مكاناً متاحاً",
    },
    thisDevice: "هذا الجهاز",
    unused: "غير مستخدم",
    lastUsed: "آخر استخدام: {when}",
    never: "أبداً",
    daysAgo: {
      one: "منذ يوم",
      two: "منذ يومين",
      few: "منذ {count} أيام",
      other: "منذ {count} يوماً",
    },
    signsOut: "سيؤدي هذا إلى تسجيل خروج هذا الجهاز.",
    releaseIt: "تحريره؟",
    release: "تحرير",
    releasing: "جارٍ التحرير…",
    moreDevices:
      "تحتاج أكثر من {limit} أجهزة؟ هذا يتعلق باشتراكك — تواصل معنا وسنرفع الحد.",
  },
};

export default devices;
